/**
 * CommissionsRoute — skin-aware switcher for /commissions.
 */
import { useUISkin } from "@/data/UISkinContext";
import Commissions from "./Commissions";
import CommissionsCockpit from "./CommissionsCockpit";

export default function CommissionsRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <CommissionsCockpit />;
  return <Commissions />;
}
